<template>
  <div class="program-selector">
    <SelectInput
      v-model="programIds"
      :options="programOptions"
      placeholder="All Programs"
      :multiselect="true"
      :filter="true"
      filter-placeholder="Search programs..."
      data-cy="membership-program-selector"
    />
  </div>
</template>

<script setup lang="ts">
import debounce from "lodash/debounce";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { updateQueryParam } from "@/lib/url.js";

import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";

interface MembershipProgram {
  id: number;
  name: string;
}

const store = useStore();

const initialIds = new URLSearchParams(window.location.search)
  .getAll("membership_program_ids[]")
  .map(Number)
  .filter(Number.isFinite);
const programIds = ref<number[]>(initialIds);

const programOptions = computed(() =>
  store.state.membershipPrograms.map((program: MembershipProgram) => ({
    label: program.name,
    value: program.id
  }))
);

const dispatchFilters = debounce((ids: number[]) => {
  store.dispatch("setMembershipDashboardFilters", {
    membership_program_ids: ids.length ? ids : undefined
  });
}, 400);

watch(programIds, (newValue) => {
  updateQueryParam(
    "membership_program_ids[]",
    newValue.length ? newValue : null,
    true
  );
  dispatchFilters(newValue);
});
</script>

<style lang="scss" scoped>
.program-selector {
  width: 280px;
  flex-shrink: 0;
}
</style>
